import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentCard } from '../../models/payment-card.model';

@Component({
  selector: 'app-payment-card-list',
  templateUrl: './payment-card-list.component.html',
  styleUrls: ['./payment-card-list.component.scss'],
  imports: [CommonModule],
  standalone: true,
})
export class PaymentCardListComponent {
  @Input({ required: true }) paymentCards!: PaymentCard[];
  @Input() cardSelected!: PaymentCard | undefined;
  @Output() selected = new EventEmitter<PaymentCard>();
  @Output() removed = new EventEmitter<PaymentCard>();

  getCardBrandColors(brand: string): string {
    const brandColors: { [key: string]: [string, string] } = {
      visa: ['#1a1f71', '#36b5f4'],
      mastercard: ['#ff5f00', '#eb001b'],
      amex: ['#2e77bb', '#6ab6e1'],
      discover: ['#f7a600', '#ff7200'],
      diners: ['#006493', '#00387b'],
    };

    brand = brand.toLowerCase();

    const colors = brandColors[brand] || brandColors['visa'];

    return `background-image: linear-gradient(80deg, ${colors[0]}, ${colors[1]})`;
  }

  public canDeleteCard = false;

  removeCard(event: Event, card: PaymentCard): void {
    if (!this.canDeleteCard) return;
    event.stopImmediatePropagation();
    this.removed.emit(card);
  }
}
